module.exports = __webpack_public_path__ + "static/media/Logo.b0ac1a27.png";